import React from "react";

import { Modal } from "src/components/Modal";
import { InlineNotification } from "src/components/Notifications/InlineNotification";
import { useGetIdentifiedCasesGraphData } from "src/dynamic-view-renderer/Widgets/RelatedCases/IdentifierGraph/identifierGraph.mapping.ts";
import { RelatedCasesDisplayElementConfig } from "src/dynamic-view-renderer/Widgets/RelatedCases/relatedCases.typings.ts";
import { WidgetProperty } from "src/dynamic-view-renderer/Widgets/Widget.typings.ts";
import useIdentifiedCases from "src/graphql/anti-fraud/queries/alerts/GetIdentifiedCasesQuery.ts";
import { useT } from "src/internationalization";

import RelatedCasesGraphComponent from "../Graph/RelatedCasesGraphComponent";

export type IdentifierGraphModalProps = {
  closeModal: () => void;
  subTitle: React.ReactNode;
  identifier: WidgetProperty;
  configuration: RelatedCasesDisplayElementConfig[];
};

const IdentifierGraphModal: React.FC<IdentifierGraphModalProps> = ({
  closeModal,
  identifier,
  configuration,
  subTitle,
}) => {
  const t = useT();

  const {
    data: identifiedCases,
    loading,
    error,
  } = useIdentifiedCases({
    identifierId: identifier.id ?? "",
    options: { pagination: { limit: 20, offset: 0 } },
  });

  const { graphData, graphLayout, graphStyles } = useGetIdentifiedCasesGraphData(
    identifiedCases,
    configuration,
    identifier
  );

  return (
    <Modal
      title={subTitle}
      onClose={closeModal}
      size="lg"
      fullHeight={loading || !error}
      noPaddingX
      closeOnEscape={false}
      closeOnOutsideClick={false}
    >
      {error && (
        <div className="p-5 h-full">
          <InlineNotification kind="error" title={t("general.error")} subtitle={error.message} />
        </div>
      )}
      {!error && (
        <div style={{ width: "100%", height: "100%" }}>
          <RelatedCasesGraphComponent
            isFullScreen={false}
            graphData={graphData}
            isLoading={loading}
            graphLayout={graphLayout}
            graphStyles={graphStyles}
          />
        </div>
      )}
    </Modal>
  );
};

export default IdentifierGraphModal;
